import React from 'react';

interface APPMessage {
  id: string;
  messageBody: string;
  from: string;
  to: string;
  receivedAt: string;
  read: boolean;
  method: string;
}

interface ThreadProfiles {
  [inboxId: string]: { name: string };
}

interface APPThreadProps {
  messages: APPMessage[];
  currentInboxId: string;
  profiles?: ThreadProfiles;
}

const APPThread: React.FC<APPThreadProps> = ({
  messages,
  currentInboxId,
  profiles,
}) => {
  const getProfileName = (inboxId: string) => {
    return profiles?.[inboxId]?.name || 'Unknown';
  };

  return (
    <div className="no-scrollbar pb-6">
      <div className="flex flex-col space-y-2">
        {messages.map((msg, index) => {
          // Message is "from me" if it was sent from the current inbox
          const isFromMe = msg.from === currentInboxId;
          const timestamp = new Date(msg.receivedAt).toLocaleString();
          const senderName = getProfileName(msg.from);

          return (
            <div
              key={msg.id || index}
              className={`flex ${isFromMe ? 'justify-end' : 'justify-start'}`}
            >
              <div
                className={`max-w-[70%] rounded-lg p-2 ${
                  isFromMe ? 'bg-blue-200' : 'bg-gray-200'
                }`}
              >
                <p className="whitespace-pre-wrap wrap-break-word">{msg.messageBody}</p>
                <div className="mt-1 text-xs text-gray-600">
                  {timestamp} - {senderName}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default APPThread;
